import React from 'react';
import { CheckCircle2 } from 'lucide-react';
const modules = [{
  title: 'Yoga Posturale e Benessere della Schiena™',
  description: 'Sequenze complete per cervicale, dorsale e lombare, protocolli per allievi sedentari e schemi pronti per il yoga da ufficio. Ogni sessione include obiettivo, schema delle asana e guida al pranayama.'
}, {
  title: 'Vinyasa e Flow Dinamico™',
  description: '15 lezioni complete divise per focus: apertura delle anche, torsioni ed equilibri. Transizioni spiegate passo dopo passo per classi fluide, progressive e adattabili a diversi livelli di intensità.'
}, {
  title: 'Yin, Rilascio e Rigenerazione™',
  description: 'Sequenze complete di Yin Yoga e yoga rigenerativo con script pronti per guidare il rilassamento profondo, la gestione dello stress e le sessioni di Yoga Nidra.'
}, {
  title: 'Yoga per Bisogni Specifici™',
  description: 'Protocolli pronti per sportivi, terza età e principianti assoluti. Modificazioni complete per ogni asana con indicazioni precise per allievi con limitazioni fisiche o condizioni particolari.'
}, {
  title: 'Lezioni Tematiche e Stagionali™',
  description: "Sequenze basate sui 5 elementi e sui cambi di stagione secondo i principi dell'Ayurveda Yoga. Focus su detox in primavera e conservazione dell'energia in inverno per armonizzare corpo e natura."
}, {
  title: 'Masterclass e Workshop Pronti™',
  description: '5 strutture complete per lezioni da 90 a 120 minuti pronte da usare nei tuoi eventi speciali. Temi: Apertura del Cuore, Forza e Radicamento, Il Viaggio nei Chakra, Equilibrio e Presenza, Rinnovamento Totale.'
}];
export function TomiSection() {
  return <section className="py-16 px-4 bg-brand-green text-white border-b-8 border-brand-dark" data-id="element-179">
      <div className="max-w-5xl mx-auto" data-id="element-180">
        <div className="text-center mb-12" data-id="element-181">
          <p className="text-brand-gold font-bold uppercase tracking-widest mb-2" data-id="element-182">
            6 Moduli Professionali In 1 Sistema Completo di Yoga
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-6 tracking-tight uppercase leading-tight" data-id="element-183">
            LA SOLUZIONE CHE STAVI CERCANDO
            <br data-id="element-184" />
            UN SISTEMA COMPLETO 6 IN 1
          </h2>

          <div className="inline-block bg-white text-brand-dark px-6 py-3 rounded-md mb-6 shadow-xl border-b-4 border-gray-300" data-id="element-185">
            <p className="font-black text-lg sm:text-xl tracking-wide uppercase" data-id="element-186">
              🧘 YOGA PRO™ — Box Set Completo 6 in 1
            </p>
          </div>

          <p className="text-base sm:text-lg text-white/90 font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-187">
            YOGA PRO™ è molto più di una raccolta di sequenze ed esercizi. È un
            sistema operativo completo per insegnanti e coach di yoga,
            progettato per aiutarti a pianificare più velocemente, insegnare
            meglio e offrire programmi di yoga professionali con piena
            sicurezza.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-188">
          {modules.map((module, i) => <div key={i} className="bg-white text-brand-dark p-6 sm:p-8 rounded-xl shadow-2xl flex gap-4 items-start border-l-8 border-brand-gold" data-id="element-189">
              <CheckCircle2 className="w-8 h-8 text-brand-green shrink-0 mt-1" data-id="element-190" />
              <div data-id="element-191">
                <h3 className="text-lg sm:text-xl font-black text-brand-dark leading-tight mb-2 uppercase" data-id="element-192">
                  {module.title}
                </h3>
                <p className="text-brand-dark/80 text-sm sm:text-base font-medium leading-relaxed" data-id="element-193">
                  {module.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}